import React, { Fragment, useState, FC } from "react";
// import { Popover, Transition } from "@headlessui/react";
// import {FactsFeaturesDataType } from "data/types";


export interface StayDatesRangeInputProps {
  className?: string;
  defaultOpen?: boolean;
  value?: String;
}

const RentalValue: FC<StayDatesRangeInputProps> = ({
  className = "flex-1",
  defaultOpen = false,
  value
}) => {

    const [isOpen, setIsOpen] = useState(defaultOpen);
  

    function showFacts(){
        setIsOpen(!isOpen);
        
    }

    const renderDetail = () => {
        if (!isOpen) return null;
        return (
            <div className="flex flex-col ml-[20px] justify-left" >
            <span className="flex mt-[10px] text-xl font-bold ">
             ${value}/mo
            </span>

            <span className="mb-[30px] flex text-neutral-900 dark:text-neutral-100">
              Rent estimate
            </span>
          </div>
        );
      };
    
      return (
        <div
          className={`justify-center  relative overflow-hidden  transition-shadow  ${className}`}>
          <div className="flex flex-row w-full " onClick={showFacts} >
                <div className="my-[9px] text-left w-5/6" >
                        <span className="pl-[15px] block text-md font-semibold  flex items-center justify-left h-full">
                        Rental Value
                        </span>
                </div>
                <div className={`flex  w-1/6 justify-end text-white ${isOpen ? "" : ""}`}>
                    <span className="flex rounded-tr-lg items-center justify-center w-[30px] bg-[#00D3DB] cursor-pointer rounded-bl-md">
                        {isOpen ? (
                        <i className=" text-xl font-bold las la-minus"></i> 
                        ) : (
                        <i className="text-xl font-bold las la-plus"></i> 
                        )}
                    </span>
                </div>
                
          </div>
          {/* DETAIL */}
          {renderDetail()}
        </div>
      );
    };

export default RentalValue;
